import React, { useEffect, useLayoutEffect } from "react";
import JsonSchemaForms from "../../../json_schema_forms";
import loan_details from "./loanDetails.json";
import { connect } from "react-redux";
import {
  mapDispatchToProps,
  mapStateToProps,
  setValueByRecursion,
} from "../../../helpers";
import _ from "lodash";
import { useTranslation, Trans } from "react-i18next";

function LoanDetails(props) {
  const [state, setState] = React.useState({ purposeOfLoan: {} });
  const [jsonSchema, setJsonSchema] = React.useState(_.cloneDeep(loan_details));
  // useTranslation();

  useEffect(() => {
    return () => {
      setJsonSchema(_.cloneDeep(loan_details));
    };
  }, []);

  useEffect(() => {
    if (!_.isEmpty(props.componentState)) {
      setState(props.componentState);
    }
  }, [props.componentState]);

  useEffect(() => {
    if (props.componentSchema?.loanDetails) {
      setJsonSchema(props.componentSchema["loanDetails"]);
    }
  }, [props.componentSchema]);

  useLayoutEffect(() => {
    let propertyType =
      props.componentState?.propertyDetails?.PropertyType?.PropertyType;
    let tempState = props.componentState;
    let tsum = {
      propertyType: "",
    };
    let loanProductData = {
      gsePropertyType: "",
    };
    switch (propertyType) {
      case "Single Family Residence":
        tsum.propertyType = "1 Unit";
        loanProductData.gsePropertyType = "Detached";
        break;
      case "2+ Units":
        tsum.propertyType = "2-4 Units";
        loanProductData.gsePropertyType = "Detached";
        break;
      case "Condominium":
        tsum.propertyType = "Condominium";
        loanProductData.gsePropertyType = "Condominium";
        break;
      case "Co-Operative":
        tsum.propertyType = "Cooperative";
        loanProductData.gsePropertyType = "Cooperative";
        break;
      case "Manufactured/Mobile Home (Single Wide)":
        tsum.propertyType = "Manufactured Housing Single Wide";
        loanProductData.gsePropertyType = "ManufacturedHousing";
        break;
      case "Manufactured/Mobile Home (Multiwide)":
        tsum.propertyType = "Manufactured Housing Multiwide";
        loanProductData.gsePropertyType = "ManufacturedHousing";
        break;
      case "Townhouse":
        tsum.propertyType = "PUD";
        loanProductData.gsePropertyType = "Attached";
        break;
      case "Single Family Residence with Home Owners Association":
        tsum.propertyType = "PUD";
        loanProductData.gsePropertyType = "PUD";
        break;
      default:
        tsum.propertyType = "";
        break;
    }
    let purposeOfLoan = _.get(
      props.componentState,
      ["purposeOfLoan", "LoanPurpose"],
      {}
    );
    let refinancingPrimaryHomeIndicator = _.get(
      props.componentState,
      ["propertyDetails", "loanPurposeConditional", "AreYouRefinancingYourPrimaryHome?", "AreYouRefinancingYourPrimaryHome?"],
      {}
    );
    if (purposeOfLoan !== "Purchase" && refinancingPrimaryHomeIndicator === "Yes") {
      let updatedSchema = setValueByRecursion(
        jsonSchema,
        [
          "properties",
          "propertyDetails",
          "properties",
          "PropertyUse",
          "properties",
          "PropertyUse",
          "disabled"
        ],
        (i) => true,
        []
      );
      setJsonSchema(updatedSchema);
    }
    tempState = setValueByRecursion(tempState, ["tsum"], (i) => tsum, [{}]);
    tempState = setValueByRecursion(tempState, ["loanProductData"], (i) => loanProductData, [{}]);
    setState(tempState);
    props.copyStateToRedux(tempState);
  }, [props.componentState?.propertyDetails?.PropertyType?.PropertyType]);


  useEffect(() => {
    if (state?.propertyDetails?.loanPurposeConditional?.["HaveYouIdentifiedAHomeToPurchase?"]?.["HaveYouIdentifiedAHomeToPurchase?"] === "No") {
      delete state?.propertyDetails?.loanPurposeConditional?.["HaveYouIdentifiedAHomeToPurchase?"]?.["HaveYouSignedAContract?"];
      setState(state);
    }
    if (state?.purposeOfLoan?.["DoYouHaveASecondMortgage?"] !== "Yes") {
      delete state?.purposeOfLoan?.SecondMortgageAmount
      setState(state)
    }
  }, [state]);

  useEffect(() => {
    if (props.componentSchema?.loanDetails) {
      if (parseFloat(state?.purposeOfLoan?.DownPaymentAmount) >= 0) {
        // from jsonSchema find and get object with description "Down Payment Amount"
        let tempSchema = props.componentSchema["loanDetails"];
        let downPaymentAmountObject = Object(tempSchema).properties.purposeOfLoan.properties.DownPaymentAmount;
        delete props.errorsDictionary["DownPaymentAmount"];
        delete downPaymentAmountObject.error;
        props.copySchema(tempSchema, "loanDetails");
      }
    }
  }, [state?.purposeOfLoan?.DownPaymentAmount, state?.purposeOfLoan?.DownPaymentPercentage]);

  //if DownPaymentPercentage has valid value then set the error to false and delete the error from errorsDictionary
  useEffect(() => {
    if (props.componentSchema?.loanDetails) {
      // Check if DownPaymentPercentage is a decimal with exactly two decimal places
      const downPaymentPercentage = state?.purposeOfLoan?.DownPaymentPercentage;
  
      // Regular expression to match a number with 0-99, followed by a decimal point, and exactly two digits after it
      const validDecimalRegex = /^\d+(\.\d{1,})?$/;
  
      if (
        downPaymentPercentage >= 0 &&
        downPaymentPercentage < 100 &&
        validDecimalRegex.test(downPaymentPercentage) &&
        Number(downPaymentPercentage) === downPaymentPercentage // To ensure no rounding issues
      ) {
        // Find and get object with description "Down Payment Percentage"
        let tempSchema = props.componentSchema["loanDetails"];
        let downPaymentPercentageObject = tempSchema.properties.purposeOfLoan.properties.DownPaymentPercentage;
        
        // Clean up error from previous validation if any
        delete props.errorsDictionary["DownPaymentPercentage"];
        delete downPaymentPercentageObject.error;
  
        // Update schema with the new value
        props.copySchema(tempSchema, "loanDetails");
      }
    }
  }, [
    state?.purposeOfLoan?.DownPaymentPercentage,
    state?.purposeOfLoan?.DownPaymentAmount,
    state?.purposeOfLoan?.EstimatedPurchasePrice,
    state?.purposeOfLoan?.EstimatedPropertyValue
  ]);
  

  const calcDownPaymentAmountOrDownPaymentPercentage = (stateToUpdate, item) => {
    let estimatedPurchasePrice = _.get(
      stateToUpdate,
      ["purposeOfLoan", "EstimatedPurchasePrice"],
      "0"
    );
    estimatedPurchasePrice =
      estimatedPurchasePrice === "" ? 0 : parseInt(estimatedPurchasePrice);
    if (
      _.get(stateToUpdate, ["purposeOfLoan", "DownPaymentAmount"]) ===
      _.get(state, ["purposeOfLoan", "DownPaymentAmount"])
    ) {
      let dpPercentage = parseFloat(
        _.get(stateToUpdate, ["purposeOfLoan", "DownPaymentPercentage"], "0")
      );

      let downPaymentAmountCalcVal = (
        (dpPercentage * estimatedPurchasePrice) /
        100
      ).toFixed(2);
        stateToUpdate = setValueByRecursion(
          stateToUpdate,
          ["purposeOfLoan", "DownPaymentAmount"],
          (i) => parseFloat(downPaymentAmountCalcVal) || 0,
          [0]
        );
    }
    if (
      _.get(stateToUpdate, ["purposeOfLoan", "DownPaymentPercentage"]) ===
      _.get(state, ["purposeOfLoan", "DownPaymentPercentage"])
    ) {
      let downpaymentAmount = parseFloat(
        _.get(stateToUpdate, ["purposeOfLoan", "DownPaymentAmount"], "0")
      );
      if (estimatedPurchasePrice > 0) {
        let downPaymentPercentageCalcVal = (
          (downpaymentAmount / estimatedPurchasePrice) *
          100.0
        ).toFixed(2);
          stateToUpdate = setValueByRecursion(
            stateToUpdate,
            ["purposeOfLoan", "DownPaymentPercentage"],
            (i) => parseFloat(downPaymentPercentageCalcVal) || 0,
            [0]
          );
      }
    }
    return stateToUpdate;
  };
  const disableAllFields = (schema, disabled) => {
    const newSchema = { ...schema };
    if (newSchema.properties) {
      Object.keys(newSchema.properties).forEach(key => {
        newSchema.properties[key] = disableAllFields(newSchema.properties[key], disabled);
      });
    }
    if ((newSchema.type && newSchema.type !== 'object') && (newSchema !== null) && (newSchema.type !== 'labelCal') ) {
      newSchema.disabled = true;
    }
    return newSchema;
  }

  const onLoadFunc = (updatedSchema) => {
    const bIdentifier = parseInt(window.localStorage.getItem("bidentifier"));
    if (bIdentifier > 0) {
      const disabledSchema = disableAllFields(updatedSchema, true);
      props.copySchema(disabledSchema, "loanDetails");
    }
    else{
      props.copySchema(updatedSchema, "loanDetails");
    }
  };

  const roundOffEstimatedPurchasePriceAndEstimatedPropertyValue = _.debounce((updatedState) => {
    // Define the paths to process
    const fields = [
        { path: ["purposeOfLoan", "EstimatedPurchasePrice"], label: "EstimatedPurchasePrice" },
        { path: ["purposeOfLoan", "EstimatedPropertyValue"], label: "EstimatedPropertyValue" }
    ];

    // Process each field to check and round if necessary
    fields.forEach(field => {
        const value = _.get(updatedState, field.path, "0");
        
        if (value) {
            const valueStr = value.toString();
            const hasDecimal = valueStr.includes('.') && valueStr.split('.')[1].length > 0;
            
            if (hasDecimal) {
                // Round off the value and update the state
                updatedState = setValueByRecursion(
                    updatedState,
                    field.path,
                    () => Math.round(value),
                    []
                );
                // Update state after all fields are processed
                props.copyStateToRedux(updatedState);
            }
        }
    });
  }, 500);

  
  const changeHandler = (updatedState, updatedSchema, label, item) => {
    let AreYouRefinancingYourPrimaryHome =
      updatedState?.propertyDetails?.loanPurposeConditional?.[
      "AreYouRefinancingYourPrimaryHome?"
      ]?.["AreYouRefinancingYourPrimaryHome?"];
    let LoanPurpose = _.get(updatedState, ["purposeOfLoan", "LoanPurpose"]);
    let PropertyUse_disability = false;
    const constructionMethodType = _.get(updatedState, ["propertyDetails", "PropertyType", "Construction Method Type"]);

    if (/LoanPurpose/i.test(label) && LoanPurpose === "Purchase") {
      updatedState = setValueByRecursion(
        updatedState,
        ["propertyDetails", "PropertyUse", "PropertyUse"],
        (i) => "",
        []
      );
      updatedState = setValueByRecursion(
        updatedState,
        ["propertyDetails", "PropertyUse", "WillYouSetAsideSpace"],
        (i) => "",
        []
      );
    }
    if (
      updatedState?.purposeOfLoan?.EstimatedPurchasePrice !==
      state.purposeOfLoan?.EstimatedPurchasePrice
    ) {
      updatedState.purposeOfLoan["EstimatedPropertyValue"] =
        updatedState.purposeOfLoan["EstimatedPurchasePrice"];
    }
    updatedState = calcDownPaymentAmountOrDownPaymentPercentage(updatedState, item);
    const estimatedPurchasePrice = _.get(updatedState, ["purposeOfLoan", "EstimatedPurchasePrice"]);
    const estimatedPropertyValue = _.get(updatedState, ["purposeOfLoan", "EstimatedPropertyValue"]);
    if((estimatedPurchasePrice || estimatedPropertyValue) && (label === "EstimatedPurchasePrice" || label === "EstimatedPropertyValue")) {
      // Call the debounced roundOffEstimatedPurchasePriceAndEstimatedPropertyValue function
      roundOffEstimatedPurchasePriceAndEstimatedPropertyValue(updatedState);
    }
    const loanAmount =
      _.get(updatedState, ["purposeOfLoan", "EstimatedPurchasePrice"]) -
      _.get(updatedState, ["purposeOfLoan", "DownPaymentAmount"], 0);

    if (loanAmount > 0) {
      updatedState = setValueByRecursion(
        updatedState,
        ["purposeOfLoan", "YourLoanAmount"],
        (i) => loanAmount,
        [0]
      );
    } else {
      delete _.get(updatedState, ["purposeOfLoan"])["YourLoanAmount"];
    }

    if (
      AreYouRefinancingYourPrimaryHome === "Yes" &&
      LoanPurpose !== "Purchase"
    ) {
      updatedState = setValueByRecursion(
        updatedState,
        ["propertyDetails", "PropertyUse", "PropertyUse"],
        (i) => "Primary Residence",
        []
      );
      PropertyUse_disability = true;
    } else {
      PropertyUse_disability = false;
    }

    if (!constructionMethodType?.hasOwnProperty("ConstructionMethodType")) {
      if (constructionMethodType) {
        delete constructionMethodType["ConstructionMethodDescription?"];
      }

      updatedState = setValueByRecursion(
        updatedState,
        ["propertyDetails", "PropertyType", "Construction Method Type"],
        (i) => constructionMethodType,
        []
      );
    }

    if (LoanPurpose === "Purchase") {
      delete _.get(updatedState, ["purposeOfLoan"])["DoYouWantToPayOffThisLoanWithTheNewLoan?"];
      delete _.get(updatedState, ["purposeOfLoan"])["SecondMortgageAmount"];
    }


    const SourceOfDownPayment = _.get(updatedState, [
      "purposeOfLoan",
      "SourceOfDownPayment",
      "SourceOfDownPayment",
    ]);
    const fhaGiftsRelatedValues = [
      "FHA - Gift - Seller Funded",
      "FHA - Gift - Non-seller Funded",
      "FHA - Gift - Gov't Assistance",
      "FHA - Gift - Source Relative",
      "FHA - Gift - Source Employer",
      "FHA - Gift - N/A",
      "Gift Funds",
    ];
    // Check if the LoanPurpose is "Purchase" and SourceOfDownPayment is fhaGiftsRelatedValues
    if (
      fhaGiftsRelatedValues.includes(SourceOfDownPayment)
    ) {
      // Do nothing, allow the Gift Amount to remain as-is
    } else {
      // Clear the Gift Amount field and ExplanationOfGift
      updatedState = setValueByRecursion(
        updatedState,
        ["purposeOfLoan", "SourceOfDownPayment", "GiftAmount"],
        (i) => "",
        [0]
      );

      updatedState = setValueByRecursion(
        updatedState,
        ["purposeOfLoan", "SourceOfDownPayment", "ExplanationOfGift"],
        (i) => "",
        [0]
      );
    }
    props.copyStateToRedux(updatedState);
    setState(updatedState);
    updatedSchema = setValueByRecursion(
      updatedSchema,
      [
        "properties",
        "propertyDetails",
        "properties",
        "PropertyUse",
        "properties",
        "PropertyUse",
        "disabled",
      ],
      (i) => PropertyUse_disability,
      []
    );
    props.copyStateToRedux(updatedState);
    setState(updatedState);
    if (updatedState?.purposeOfLoan?.EstimatedPropertyValue != '') {
      delete props.errorsDictionary["EstimatedPropertyValue"];
      updatedSchema = setValueByRecursion(
        updatedSchema,
        [
          "properties",
          "purposeOfLoan",
          "properties",
          "EstimatedPropertyValue",
          "error",
        ],
        (i) => false,
        []
      );
    }
    if (updatedState?.purposeOfLoan?.EstimatedPurchasePrice > 0) {
      updatedSchema = setValueByRecursion(
        updatedSchema,
        [
          "properties",
          "purposeOfLoan",
          "properties",
          "DownPaymentAmount",
          "maximum",
        ],
        (i) => parseInt(updatedState?.purposeOfLoan?.EstimatedPurchasePrice),
        []
      );
    }
    props.copySchema(updatedSchema, "loanDetails");
  };
  // const changeLanguage = lng => {
  //   i18n.changeLanguage(lng);
  // };
  return (
    <JsonSchemaForms
      state={state}
      jsonData={jsonSchema}
      changeHandler={changeHandler}
      pageKey={"LoanDetails"}
      onLoadFunc={onLoadFunc}
    />
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(LoanDetails);
